import { CommentItem, RestAPI } from '@builddocs/data-management'

interface IGetCommentsHistory {
  externalId: string
  externalEntityInfo: string
}

export function getCommentsHistory({
  externalId,
  externalEntityInfo,
}: IGetCommentsHistory) {
  return RestAPI.get<CommentItem[]>(
    `section_four/external-entity-id/${externalId}/history?externalEntityInfo=${externalEntityInfo}`,
  ).then(r => r.data)
}
